
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import SectionPromo from "../components/home/SectionPromo";
import SectionMenu from "../components/home/SectionMenu";
import SlickSlider from "../components/home/SectionSlider";
import SectionWelcome from "../components/home/SectionWelcome";
import SectionVisit from "../components/home/SectionVisit";
import React, { useRef } from 'react';

function Home() {
  const sectionRef = useRef(null);

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-grow">
          <SlickSlider />
          <SectionPromo />
          <SectionMenu targetRef={sectionRef} />
          <SectionWelcome />
          <SectionVisit sectionRef={sectionRef} />
      </main>
      <Footer />
    </div>
  );
}

export default Home;
